module.exports = __webpack_public_path__ + "static/media/NEUPhillipsburgPOCareaDBWfeet_px18_741_0.6906077.e5eb4cf2.png";